export const toggleChat = (chatIsOpen) => {
    return (_dispatch, getState) => {
        if (typeof zE === 'function') {
            zE('messenger', chatIsOpen ? 'open' : 'close');
        } else if (__isBrowser__ && !getState().app.isShowModal && !getState().app.isShowPopup && !getState().isShowNavBar) {
            document.documentElement.style.overflow = chatIsOpen ? 'hidden' : '';
            document.body.style.overflow = chatIsOpen ? 'hidden' : '';
        }
        return Promise.resolve();
    };
};
